import { Controller, Control, FieldErrors } from 'react-hook-form';
import { Column, InputSelect, Label, MultiSelectGroup, Text } from '~/commonComponents';
import { expectedDaysOptions, scheduleTypeOptions } from '~/components/PermanentJobsV2/utils';
import type { IJobDetailsForm } from '../Types';

interface IScheduleFormProps {
  control: Control<IJobDetailsForm>;
  errors: FieldErrors<IJobDetailsForm>;
}

export const ScheduleForm = ({ control, errors }: IScheduleFormProps) => {
  return (
    <Column gap={24}>
      <Column>
        <Label text="Schedule Type" required />
        <Controller
          control={control}
          name="scheduleType"
          render={({ field }) => (
            <InputSelect
              placeholder="Select Schedule Type"
              value={field.value}
              setValue={field.onChange}
              isSelectVisible={false}
              options={scheduleTypeOptions.map((option) => ({
                title: option.name,
                value: option.code,
              }))}
              error={!!errors.scheduleType}
            />
          )}
        />
      </Column>

      <Column>
        <Label text="Expected Days" required={false} />
        <Text color="neutral_500" italic>
          <Controller
            control={control}
            name="expectedDays"
            render={({ field }) => (
              <MultiSelectGroup
                isEnableSelectAll
                value={field.value}
                options={expectedDaysOptions.map((option) => ({
                  value: option.code,
                  label: option.name,
                }))}
                onChange={(selected) => field.onChange(selected.map((s) => s.value))}
              />
            )}
          />
        </Text>
      </Column>
    </Column>
  );
};
